export const ROLE = {
  ADMIN: "admin",
  COUNCIL: "council",
  DEPARTMENT_ADMIN: "department_admin",
  DEPARTMENT_USER: "department_user",
  USER: "user",
  PARK_ADMIN: "park_admin",
  PARK_USER: "park_user",
};
